<mat-form-field *ngIf="existingOfficers" appearance="outline" class="w-1/3">
  <mat-label>Select {{ officerRoleLabel }}</mat-label>
  <input
    type="text"
    placeholder="Pick one"
    matInput
    required
    data-cy="existing-officer-input"
    [formControl]="officerFilterControl"
    [matAutocomplete]="auto"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="getDisplayExistingOfficerName"
    (optionSelected)="onExistingOfficerSelected($event)"
  >
    <ng-container *ngIf="filteredOfficers$ | async as options">
      <ng-container *ngIf="options.length > 0; else noOptions">
        <mat-option
          *ngFor="let option of options"
          [value]="option.id"
          data-cy="existing-officer-option"
          class="!py-1 !h-fit"
        >
          <div class="inline-flex items-center">
            <mat-icon
              *ngIf="isIndividual(option)"
              class="text-darkGray opacity-70"
              [matTooltip]="'Individual'"
              matTooltipClass="capitalize"
            >
              person
            </mat-icon>
            <mat-icon
              *ngIf="isCorporate(option)"
              class="text-darkGray opacity-70"
              [matTooltip]="'Corporate'"
              matTooltipClass="capitalize"
            >
              apartment
            </mat-icon>
            <div>
              <p class="!mb-1 !text-sub truncate">
                {{ option.name }}
              </p>
              <p class="!mb-0 mat-caption text-lightGray truncate">
                {{ option.email }}
              </p>
            </div>
          </div>
        </mat-option>
      </ng-container>
      <ng-template #noOptions>
        <mat-option disabled class="!text-center">
          No options found
        </mat-option>
      </ng-template>
    </ng-container>
  </mat-autocomplete>
  <mat-error *ngIf="officerFilterControl.invalid && officerFilterControl.errors?.required">
    Please pick a valid option
  </mat-error>
  <mat-error *ngIf="
      (filteredOfficers$ | async).length === 0 &&
      !officerFilterControl.errors?.required
    ">
    No options found. Please refine your search.
  </mat-error>
</mat-form-field>
